// Configuration for API endpoints
export const config = {
  // Use environment variable if available, otherwise fallback to localhost
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://studyadvisoragent-backend.onrender.com',
  
  // API endpoints
  ADVICE_ENDPOINT: '/api/v1/advice',
  SEARCH_ENDPOINT: '/api/v1/search',
  
  // Timeout settings
  REQUEST_TIMEOUT: 10000, // 10 seconds
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  return `${config.API_BASE_URL}${endpoint}`;
};
